export default __webpack_public_path__ + "static/me-cb98a7d25f722f82c82c04db5e8aeef3.jpg";